import React from 'react';
import HeroSection from '../components/HeroSection';
import PetCheirosoSection from '../components/PetCheirosoSection';
import MaisClientesSection from '../components/MaisClientesSection';
import ComoFuncionaSection from '../components/ComoFuncionaSection';
import PerguntasFrequentesSection from '../components/PerguntasFrequentesSection';

export function HomePage() {
  return (
    <div className="home-page">
      <HeroSection />
      <PetCheirosoSection />
      <MaisClientesSection />
      <ComoFuncionaSection />
      <PerguntasFrequentesSection />
    </div>
  );
};

